import SearchMoviesView from '@/ui/SearchMoviesView';
import { useSearchMovies } from '@/hooks/useSearchMovies';
import { jsx as _jsx } from "react/jsx-runtime";
var SearchMovies = function SearchMovies() {
    var _useSearchMovies = useSearchMovies(), searchValue = _useSearchMovies.searchValue, setSearchValue = _useSearchMovies.setSearchValue, movies = _useSearchMovies.movies, loading = _useSearchMovies.loading, error = _useSearchMovies.error, trimmed = _useSearchMovies.trimmed, resetSearch = _useSearchMovies.resetSearch;
    return /*#__PURE__*/ _jsx(SearchMoviesView, {
        searchValue: searchValue,
        setSearchValue: setSearchValue,
        movies: movies,
        loading: loading,
        error: error,
        trimmed: trimmed,
        onReset: resetSearch,
        onLinkClick: function onLinkClick() {
            return resetSearch();
        }
    });
};
export default SearchMovies;
